import { render } from "./TotalHours.vue?vue&type=template&id=8749f97a"
import script from "./TotalHours.vue?vue&type=script&lang=js"
export * from "./TotalHours.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__